import { useState } from "react";
import { StarProps } from "./star.types";
import { StarIcon } from "../../../../../infecto-lms-webapp/assets/icons/star-icon";
import { LMS_WEBAPP_CONFIG_IMPL } from "../../../../../infecto-lms-webapp-impl/config";

export const Star = ({
	onClick,
	disableHover = false,
	isActive,
	setHoveredIndex,
	index,
}: StarProps) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleOnMouseEnter = () => {
		if (disableHover) return;
		setIsHovered(true);
		setHoveredIndex(index);
	};
	const handleOnMouseLeave = () => {
		if (disableHover) return;
		setIsHovered(false);
		setHoveredIndex(null);
	};
	const brandColor = LMS_WEBAPP_CONFIG_IMPL.brandColor;
	return (
		<div onClick={onClick} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
			<StarIcon
				strokeColor={brandColor}
				width={32}
				height={32}
				fillColor={isActive || isHovered ? brandColor : "none"}
			/>
		</div>
	);
};
